import { useState, type FormEvent } from "react";
import { signInDev, signInEmail, signInGoogle } from "../../app/auth.js";
import { config, devMode } from "../../app/env.js";
import { t } from "../../shared/i18n.js";
import { Banner } from "../../shared/common.js";
import { Link } from "../../app/router.js";
import { BrandSymbol } from "../../shared/Brand.js";

/** La connexion : le nom, deux champs, un bouton blanc. Rien d'autre. */
export function Login() {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [busy, setBusy] = useState(false);
  const [error, setError] = useState<string | null>(null);

  const submit = async (e: FormEvent) => {
    e.preventDefault();
    setBusy(true);
    setError(null);
    try {
      await signInEmail(email.trim(), password);
    } catch (err) {
      const code = (err as { code?: string }).code ?? "";
      setError(code.includes("network") ? t("error.network") : t("login.bad"));
    } finally {
      setBusy(false);
    }
  };

  const google = async () => {
    setError(null);
    try {
      await signInGoogle();
    } catch (err) {
      const code = (err as { code?: string }).code ?? "";
      if (!code.includes("popup-closed")) setError(t("error.generic", { msg: code || String(err) }));
    }
  };

  return (
    <main className="login">
      <div className="login-card">
        <h1 className="logo big login-brand">
          <BrandSymbol reveal /> EditIT
        </h1>
        <p className="muted">{t("login.subtitle")}</p>
        {devMode ? (
          <div className="stack">
            <p className="small faint">{t("login.devHint")}</p>
            <button className="btn primary block lg" onClick={() => void signInDev()} data-testid="login-dev">
              {t("login.dev")}
            </button>
          </div>
        ) : (
          <form className="stack" onSubmit={submit}>
            <input
              className="input lg"
              type="email"
              autoComplete="email"
              required
              placeholder={t("login.email")}
              aria-label={t("login.email")}
              value={email}
              onChange={(e) => setEmail(e.target.value)}
            />
            <input
              className="input lg"
              type="password"
              autoComplete="current-password"
              required
              placeholder={t("login.password")}
              aria-label={t("login.password")}
              value={password}
              onChange={(e) => setPassword(e.target.value)}
            />
            {error && <Banner kind="bad">{error}</Banner>}
            <button className="btn primary block lg" type="submit" disabled={busy}>
              {t("login.submit")}
            </button>
            {config.googleAuth && (
              <button type="button" className="btn secondary block lg" onClick={() => void google()}>
                {t("login.google")}
              </button>
            )}
          </form>
        )}
        <Link className="xs faint" to="/confidentialite">
          {t("privacy.link")}
        </Link>
      </div>
    </main>
  );
}
